document.addEventListener("DOMContentLoaded", function(event) { 

  var elements = { 
    body: document.getElementsByTagName("body")[0],
    html: document.getElementsByTagName("html")[0],
    burger: document.getElementsByClassName("hamburger")[0],
    icon: document.getElementsByClassName("hamburger-icon")[0],
    nav: document.getElementById("site_navigation")
  };

  function handleTouchMove(e){ 
    e.preventDefault();
  };

  elements.burger.onclick = function() {
    elements.icon.classList.toggle("open");  
    elements.nav.classList.toggle('open'); 
    elements.html.classList.toggle('nav-open');
    elements.body.classList.toggle('nav-open');

    if (elements.body.classList.contains('nav-open')) { 
      document.addEventListener( 'touchmove', handleTouchMove, false ); 
    } else { 
      document.removeEventListener( 'touchmove', handleTouchMove ); 
    }

  };
});